import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Box } from '@mui/material';
import AllBookCheckIc from '../../assets/images/ic_mybook_check.png';

const ellipsisStyle = {
  lineHeight: '20px',
  width: '100%',
  maxWidth: '100%',
  minHeight: '30px',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  wordBreak: 'break-word',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  WebkitBoxAlign: 'center',
  textAlign: 'center',
  fontSize: '16px',
};

function TotalManualItem({ manual, onAddnRemoveBtnClick = () => {}, isMine, isAdding = false }) {
  const [hoveredManualIdx, setHoveredManualIdx] = useState(null);

  const isHovered =
    hoveredManualIdx !== null && manual?.idx === hoveredManualIdx;

  return (
    <div className="w-full h-[300px] max-h-[300px] flex justify-center items-center">
      <Box
        className="w-[152px] min-h-[198px] flex flex-col"
        onMouseEnter={() => setHoveredManualIdx(manual.idx)}
        onMouseLeave={() => setHoveredManualIdx(null)}
      >
        <Box className="relative w-full h-[198px] min-h-[198px] bg-[white] grow flex justify-center items-center">
          {isMine && (
            <img
              src={AllBookCheckIc}
              alt="bookmark"
              style={{
                position: 'absolute',
                top: '0',
                right: '0',
                width: '45px',
                height: '45px',
                zIndex: 2,
              }}
            />
          )}
          <Box
            className="w-full h-full absolute top-0 left-0 right-0 bottom-0"
            style={{
              zIndex: 1,
              background: `url(${manual?.book_imagelink})`,
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
            }}
          />
          {isHovered && (
            <Box
              onClick={() => {}}
              style={{
                zIndex: 2,
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'rgba(0, 0, 0, .3)',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
              }}
            />
          )}
          {isHovered && !isMine && (
            <Button
              variant="contained"
              sx={{ zIndex: 3, minWidth: '90px', borderRadius: '6px' }}
              onClick={() => onAddnRemoveBtnClick(manual)}
              disabled={isAdding}
            >
              <div className="flex items-center">나의 교재 추가</div>
            </Button>
          )}
          {isHovered && isMine && (
            <Button
              variant="contained"
              sx={{ zIndex: 3, minWidth: '90px', borderRadius: '6px' }}
              onClick={() => onAddnRemoveBtnClick(manual)}
            >
              <div className="flex items-center">나의 교재 해제</div>
            </Button>
          )}
        </Box>
        <Box
          className="w-full pt-[20px] h-[60px]"
          style={ellipsisStyle}
          onMouseEnter={() => {}}
          onMouseLeave={() => {}}
          onClick={() => {}}
        >
          {manual?.book_title ?? '교재'}
        </Box>
      </Box>
    </div>
  );
}

TotalManualItem.propTypes = {
  manual: PropTypes.shape({
    book_imagelink: PropTypes.string,
    book_isbn: PropTypes.string,
    book_title: PropTypes.string,
    cate_lvl1_idx: PropTypes.number,
    cate_lvl2_idx: PropTypes.number,
    created_at: PropTypes.string,
    created_by: PropTypes.number,
    idx: PropTypes.number,
  }),
  onAddnRemoveBtnClick: PropTypes.func,
  isMine: PropTypes.bool.isRequired,
  isAdding: PropTypes.bool,
};

export default TotalManualItem;
